import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { status } = useAuth();
    if (status === "loading") {
        return (
            <div
                data-testid="auth-loading"
                className="min-h-screen flex items-center justify-center text-neutral-500"
            >
                <div className="h-2 w-2 rounded-full bg-neutral-400 animate-pulse" />
            </div>
        );
    }
    if (status !== "authed") return <Navigate to="/login" replace />;
    return children;
}
